import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { LoginButton } from "@limitless/portal";
import SectionHeader from "../section-header/SectionHeader";
import ClosedOverlay from "../closed-overlay/ClosedOverlay";
import { formatToTimeZone } from "@limitless/common/utils";
import { generalSubHeaderStyles } from "../example-questions/ExampleQuestions";
const useStyles = makeStyles(theme => ({
  ...generalSubHeaderStyles(theme),
  signUpContentContainer: {
    marginTop: 8,
    paddingBottom: 24,
    textAlign: "center"
  },
  contentContainer: {
    paddingBottom: "4%"
  },
  buttonContainer: {
    paddingLeft: 0
  },
  buttonWidth: {
    width: 284,
    margin: "auto",
    display: "flex",
    justifyContent: "center"
  },
  [theme.breakpoints.up("sm")]: {
    signUpContentContainer: {
      textAlign: "left"
    },
    buttonWidth: {
      width: 234
    }
  },
  [theme.breakpoints.up("md")]: {
    buttonContainer: {
      paddingLeft: 90
    },
    buttonWidth: {
      margin: 0,
      justifyContent: "flex-start"
    }
  },
  [theme.breakpoints.up("lg")]: {
    buttonWidth: {
      width: 213
    }
  }
}));
const SignUpCta = ({
  content,
  endDate,
  hash,
  leftSpaceContainer
}) => {
  const classes = useStyles();
  const [showClosedDailog, setShowClosedDailog] = React.useState(false);
  const handleSignUpButtonClick = () => {
    const currentDate = Date.parse(new Date());
    if (endDate && endDate <= currentDate && !showClosedDailog) {
      setShowClosedDailog(true);
      content.closedSubHeader = content.closedSubHeader.replaceAll("<Onboarding campaign closed date>", formatToTimeZone(endDate, "DD/MM/YYYY HH:mm"));
    } else if (typeof endDate !== "undefined") {
      window.location.assign(`${hash}/signup`);
    }
  };
  return /*#__PURE__*/React.createElement(Grid, {
    className: leftSpaceContainer
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.header
  }), /*#__PURE__*/React.createElement(Grid, {
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    className: classes.generalSubHeaderContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary",
    className: classes.signUpContentContainer
  }, content.subHeader)), /*#__PURE__*/React.createElement(Grid, {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(LoginButton, {
    onClick: handleSignUpButtonClick,
    containerClasses: classes.buttonWidth
  }, content.buttonLabel))), /*#__PURE__*/React.createElement(ClosedOverlay, {
    content: content,
    open: showClosedDailog,
    handleCloseDailogClick: () => setShowClosedDailog(false),
    handleSignUpButtonClick: handleSignUpButtonClick
  }));
};
SignUpCta.propTypes = {
  content: PropTypes.object.isRequired,
  hash: PropTypes.string,
  endDate: PropTypes.number,
  leftSpaceContainer: PropTypes.string
};
export default SignUpCta;